import { getUserMailboxInfo } from 'owa-client-ids';
import { dedupeArrayValues } from 'owa-selected-calendars-utils';
import { trace } from 'owa-trace';
import { lazyUpdateUserConfigurationService } from 'owa-update-user-configuration-service';

export const VIEW_STATE_CONFIGURATION: string = 'OWA.ViewStateConfiguration';
export const USER_OPTIONS_CONFIGURATION: string = 'OWA.UserOptions';

export function updateSelectedCalendarsState(
    selectedCalendars: string[],
    primarySmtpAddress: string
) {
    const mailboxInfo = getUserMailboxInfo(primarySmtpAddress);
    if (selectedCalendars) {
        lazyUpdateUserConfigurationService
            .importAndExecute(
                VIEW_STATE_CONFIGURATION,
                {
                    // Key
                    Type: 'String',
                    Value: ['SelectedCalendarsDesktop'],
                },
                {
                    // Value
                    Type: 'StringArray',
                    Value: dedupeArrayValues(selectedCalendars),
                },
                mailboxInfo
            )
            .catch(error => {
                trace.warn('Could not save new selected calendars list to user configuration');
            });
    }
}
